import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/permisosDeAcceso/employees";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    employees: [],
    new: [],
    edit: [],
    deleteItem: [],
    showAdd: false,
    permissionId: null,
    openEmployee: false,
    mode: "",
    openDelete: false,
  },

  mutations: {
    setEmployees(state, data) {
      state.employees = data;
    },
    setEdit(state, data) {
      state.edit = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setShowAdd(state, data) {
      state.showAdd = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setOpenEmployee(state, data) {
      state.openEmployee = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
    setPermissionId(state, data) {
      state.permissionId = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
  },
  actions: {
    async getEmployees(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.getEmployees(
            state.state.permissionId
          );

          state.commit("setEmployees", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async edit(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.edit(state.state.edit).then(() => {
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async new(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.new(state.state.new).then(() => {
            state.dispatch("getEmployees");
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    async delete(state) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.delete(state.state.deleteItem).then(() => {
            let options = state.state.employees;
            options = options.filter((option) => {
              return option.id != state.state.deleteItem.id;
            });
            state.commit("setEmployees", options);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
